// App.tsx
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Pdftotxt from "./pages/PdfToTextPage";
import Home from "./pages/HomePage";
import NoPage from "./pages/NotFoundPage";
import LoginFractional from "./pages/auth/LoginFractionalPage";
import Redirect from "./pages/auth/RedirectPage";
import P7mPage from "./pages/P7mPage";
import "./styles/pages/App.scss";
import "@appkit4/react-components/dist/styles/appkit4-react.min.css";
import DoComparePage from "./pages/DoComparePage";
import DocSimilarityPage from "./pages/DocSimilarityPage";
import { ProtectedRoute } from "./components/utility/ProtectedRoute/ProtectedRoute";
import { Sentry } from "./config/sentry";
import SentryRouteTags from "./components/utility/SentryRouteTags/SentryRouteTags";
import { useTokenValidation } from "./hooks/useTokenValidation";

// Componente interno per gestire routing e validazione token
function AppContent() {
  // Background token validation: runs once at boot, redirects to /login if token is
  // invalid or expired. Does not block rendering — ProtectedRoute handles synchronous
  // token-presence checks on each route; apiClient handles 498 (expired) on API calls.
  useTokenValidation();

  return (
    <>
      {/* Tag Sentry per tracking route e microservizi */}
      <SentryRouteTags />
      <Routes>
        <Route path="/" element={<ProtectedRoute element={<Home />} />} />
        <Route path="/pdftotxt" element={<ProtectedRoute element={<Pdftotxt />} />} />
        <Route path="/p7mpage" element={<ProtectedRoute element={<P7mPage />} />} />
        <Route path="/DoCompare" element={<ProtectedRoute element={<DoComparePage />} />} />
        <Route path="/DocSimilarity" element={<ProtectedRoute element={<DocSimilarityPage />} />} />
        <Route path="/login" element={<LoginFractional />} />
        <Route path="/redirect" element={<Redirect />} />
        <Route path="*" element={<ProtectedRoute element={<NoPage />} redirectTo="/" />} />
      </Routes>
    </>
  );
}

function App() {
  // Imposta tema dark globale al mount dell'app
  useEffect(() => {
    document.body.setAttribute("data-theme", "dark");
    document.body.setAttribute("data-mode", "dark");
    document.body.classList.add("no-outline");
  }, []);

  return (
    // ErrorBoundary Sentry: cattura errori React non gestiti e mostra fallback UI
    <Sentry.ErrorBoundary fallback={<h1>Something went wrong.</h1>}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

// Profiler Sentry per tracking performance rendering del componente App
export default Sentry.withProfiler(App, { name: "App" });